import { createGlobalStyle } from "styled-components";

export const GlobalStyles = createGlobalStyle`
/*
  1. Use a more-intuitive box-sizing model.
*/
*,
*::before,
*::after {
  box-sizing: border-box;
  -webkit-tap-highlight-color: rgba(0,0,0,0);
}
/*
  2. Remove default margin and padding
*/
* {
  margin: 0;
  padding: 0;
}

/*
 2.1 disable text select
*/
* {
	-webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
    -khtml-user-select: none; /* Konqueror HTML */
	-moz-user-select: none; /* Old versions of Firefox */
	-ms-user-select: none; /* Internet Explorer/Edge */
    user-select: none; /* Non-prefixed version, currently supported by Chrome, Edge, Opera and Firefox */
}
// Exception for input areas 
input,textarea {
    -webkit-touch-callout: default !important;
    -webkit-user-select: text !important;
	user-select: text !important;
}

/*
  3. Allow percentage-based heights in the application
*/
html {
  font-size: 16px;
}

html, body {
  height: 100%;
  background-color: #ffffff;
  overflow-behavior: none;
}
/*
  Typographic tweaks!
  4. Add accessible line-height
  5. Improve text rendering
*/
body {
  line-height: 1.5;
  letter-spacing: -0.2px;
  color: #26282b;
  
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-family: "Pretendard", "AppleSDGothicNeo", "AppleSDGothicNeo-Regular", "Malgun Gothic", Helvetica, sans-serif;
}
/*
  6. Improve media defaults
*/
img, picture, video, canvas, svg {
  display: block;
  max-width: 100%;
}
/*
  7. Remove built-in form typography styles
*/
input, button, textarea, select {
  font: inherit;
}
/*
  8. Avoid text overflows
*/
p, h1, h2, h3, h4, h5, h6 {
  overflow-wrap: break-word;
}
/*
  9. Create a root stacking context
*/
#root, #__next {
  isolation: isolate;
  height: 100%;
  width: 100%;
}

/*
  10. 
*/
a															{outline:none; text-decoration:none; color:inherit}
a:hover														{cursor:pointer}
a:disabled													{opacity:0.33}

table														{border-collapse:collapse; border-spacing:0; table-layout:fixed}
img															{border:none; outline:none; pointer-events:none}
ul															{list-style:none}
input, select, button, textarea								{transition:border 0.25s; -webkit-appearance:none; -moz-appearance:none; -ms-appearance:none; appearance:none}

input:disabled												{background-color:var(--disabled); border-color:var(--border)}
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button				{-webkit-appearance:none}
select::-ms-expand											{display:none}
input[type=file]											{opacity:0; cursor:pointer}
input:focus, select:focus, textarea:focus					{border-color:var(--primary) !important; outline:none}

em, var, ins, del											{font-style:normal; text-decoration:none}
var, time													{font-style:normal}
p															{text-align:justify}
hr															{margin:10px 0; padding:0; height:0; border:none; border-bottom:1px solid var(--border)}

h1															{font-size:2rem}
h2															{font-size:1.5rem}
h3															{font-size:1.25rem}
h4															{font-size:1.125rem}
h5															{font-size:1rem; font-weight:400; color:var(--gray)}
h6															{font-size:0.75rem; font-weight:400; color:var(--gray)}
h1, h2, h3, h4, h5, h6										{line-height:1.2}

/*
  11. 
*/
:root {
	--primary: #003fbd;
	--secondary: #083ea9;
	--disabled: #e4e8f2;
	--border: #e1e6ed;
	--lightBorder: #f2f2f4;
	--focus: rgba(33,150,243,0.1);

	--red: #f43e3e;
	--orange: #f39800;
	--yellow: #ffcd56;
	--green: #37b772;
	--blue: #004fec;
		
	--purple: #7a52cc;
	--gray: #9a9ea8;
	--darkGray: #838791;
	--gray40: #838791;
	--gray50: #70747d;

	
	--black: #26282b;
	--blueBlack: #4c5874;
	
	--white: #fff;
	--darkBlue: #42485a;
	
	--success: #0daa39;
	--failed: #da2e2e;
	
	--lightRed: #f3c4c4;
	--lightBlue: #f3f7ff;
	--lightGray: #f2f4f6;
	
	--package: #37b772;
	--appointment: #7a57c9;
	--class: #f19825;
	--place: #0e55e8;
	--option: #53bbd0;
	
	--bg-appointment: #f0eaff;
	--bg-class: #fff2e2;
	--bg-place: #e8efff;
	--bg-option: #e3f6ff;
	
	--padding: 16px;
	--lineHeight: 46px;
	--borderRadius: 12px;
	
	--10px: 0.5rem;
	--11px: 0.6875rem;
	--12px: 0.75rem;
	--13px: 0.8125rem;
	--14px: 0.875rem;
	--15px: 0.9375rem;
	--16px: 1rem;
	--18px: 1.125rem;
	--22px: 1.375rem;
}

::placeholder {
	color: var(--gray);
}

/*
  12. 
*/
.color	{
	.red			{color:var(--red)}
	.orange			{color:var(--orange)}
	.yellow			{color:var(--yellow)}
	.green			{color:var(--green)}
	.blue			{color:var(--blue)}
	.purple			{color:var(--purple)}
	.gray			{color:var(--gray)}
	.darkGray		{color:var(--darkGray)}

	.package		{color:var(--package)}
	.appointment	{color:var(--appointment)}
	.class			{color:var(--class)}
	.place			{color:var(--place)}
	.option			{color:var(--option)}	
	}
`;
